export default __webpack_public_path__ + "static/media/visseria.5f59f578.png";